import React from 'react';
import { motion } from 'framer-motion';
import { Shield, BookCopy, Gift, Star } from 'lucide-react';
export function StatsStrip() {
  const stats = [{
    icon: Shield,
    text: '+300 docentes protegidos'
  }, {
    icon: BookCopy,
    text: '6 Tomos listos'
  }, {
    icon: Gift,
    text: '6 Bonos incluidos'
  }, {
    icon: Star,
    text: '4.9/5 calificación ⭐'
  }];
  return <div className="bg-white border-b border-stone-200 py-6 px-4" data-id="element-298">
      <div className="max-w-6xl mx-auto" data-id="element-299">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-id="element-300">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-center justify-center text-center gap-2" data-id="element-301">
              <stat.icon className="w-6 h-6 text-brand-600" data-id="element-302" />
              <span className="font-semibold text-stone-700 text-sm md:text-base" data-id="element-303">
                {stat.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </div>;
}